import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-details-view-container',
  templateUrl: './details-view-container.component.html',
  styleUrls: ['./details-view-container.component.scss']
})
export class DetailsViewContainerComponent implements OnInit {
  entity = "";
  isOrgDetails = false;
  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    const safeEntity = this.route.snapshot.paramMap.get("entity");

    if (safeEntity != undefined){
      this.entity = safeEntity;
    }

  }

}
